<template>
  <hm-content title="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="130px"
      v-if="type !== 'plus_card'"
    >
      <el-form-item label="计划名称" prop="planName">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.planName"
          placeholder="请输入计划名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="计划人群" prop="renqun">
        <div>{{ renqun }}</div>
      </el-form-item>
      <el-form-item
        label="绑定会员卡类型"
        prop="cardTypeIdList">
       <el-select
          size="small"
          clearable
          style="width: 350px"
          v-model="ruleForm.cardTypeIdList"
          class="mr10"
          placeholder="请选择PLUS会员绑定会员卡类型"
          filterable
          @change="validationCardType"
          multiple
        >
          <el-option
            label="全部"
            value="0"
            :disabled="checked"
          ></el-option>
          <el-option
            v-for="(item, i) in vipCardTypeList"
            :key="i"
            :label="item.typeName"
            :value="item.cardTypeId"
            :disabled="item.disabled"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计划方式" prop="date">
        <el-date-picker
          clearable
          v-model="ruleForm.date"
          type="daterange"
          align="right"
          start-placeholder="请选择计划执行开始时间"
          end-placeholder="请选择计划执行结束时间"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
        ></el-date-picker>
        <!-- <el-radio-group v-model="ruleForm.planType">
          <el-radio label="automatic">自动长期计划</el-radio>
          <el-radio label="manual">手动定时计划</el-radio>
        </el-radio-group> -->
        <!-- <div v-if="ruleForm.planType === 'automatic'">
          <div class="form-tips">
            人群中如有满足条件的新增会员，新增的会员会自动收到营销通知。
          </div>
          <div>
            计划执行时间:
            <el-date-picker
              clearable
              :default-time="['00:00:00', '23:59:59']"
              v-model="ruleForm.date"
              type="datetimerange"
              align="right"
              start-placeholder="请选择开始时间"
              end-placeholder="请选择结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
            ></el-date-picker>
          </div>
        </div>
        <div v-else>
          <div class="form-tips">
            在指定时间向计划人群发送营销通知。
          </div>
          <div>
            计划执行时间:
            <el-radio-group v-model="ruleForm.planTypeTime">
              <el-radio label="immediately">立即执行</el-radio>
              <el-radio label="timing">定时执行</el-radio>
              <el-time-picker
                size="small"
                v-if="ruleForm.planTypeTime === 'timing'"
                v-model="ruleForm.planTime"
                placeholder="请选择到时分秒"
              >
              </el-time-picker>
            </el-radio-group>
          </div>
        </div> -->
      </el-form-item>
      <el-form-item label="优惠券配置" prop="sendCouponState">
        <el-checkbox
          true-label="yes"
          false-label="no"
          v-model="ruleForm.sendCouponState"
          >发放优惠券</el-checkbox
        >
        <div class="form-tips">
          发放优惠券能有效刺激转化(优惠券将直接发放给客户。不需要领取)
        </div>
        <div class="coupons-table" v-show="ruleForm.sendCouponState === 'yes'">
          <div class="flex flex-center coupons-head">
            <div class="flex-1 flex flex-center">优惠券包</div>
            <div class="flex-1 flex flex-center">可发放组数</div>
            <div class="flex-1 flex flex-center">发放组数</div>
          </div>
          <div class="flex flex-center">
            <div class="flex-1 flex flex-center blue">
              <el-select
                size="small"
                clearable
                @change="changeCounpon"
                placeholder="选择优惠券包"
                v-model="ruleForm.sendCouponCode"
                filterable
              >
                <el-option
                  v-for="(item, i) in couponList"
                  :key="i"
                  :label="item.name"
                  :value="item.couponSendId"
                ></el-option>
              </el-select>
            </div>
            <div class="flex-1 flex flex-center blue">
              {{ couponsNum === "" ? "读取" : couponsNum }}
            </div>
            <div class="flex-1 flex flex-center">
              <el-input
                :disabled="!ruleForm.sendCouponCode"
                size="small"
                clearable
                class="ipt"
                @input="filterGt0OrFixed0('totalSendNumber')"
                v-model.trim="ruleForm.totalSendNumber"
                placeholder="请输入发放组数"
              ></el-input>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="通知配置" prop="sendSmsState">
        <el-checkbox
          true-label="yes"
          false-label="no"
          v-model="ruleForm.sendSmsState"
          >短信通知</el-checkbox
        >
        <div v-if="ruleForm.sendSmsState === 'yes'">
          <el-input
            maxlength="100"
            placeholder="请输入短信内容"
            size="small"
            style="width: 500px"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="ruleForm.sendSmsContent"
          ></el-input>
          <div class="form-tips-primary">
            注意，同一个客户近7天只能收到一条人群运营的消恩模板通知，以防对客户产生骚扰1消息发送时间在700-19002间系统根据任务数量进入列队执行!
          </div>
        </div>
      </el-form-item>
      <el-form-item label="计划异常提醒" prop="reminderMobile">
        接收通知的手机号:<el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.reminderMobile"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >确认</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
    <el-form
      :model="ruleFormXdd"
      :rules="xddRules"
      ref="ruleFormXdd"
      label-width="110px"
      v-else
    >
      <el-form-item label="计划名称" prop="planName">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleFormXdd.planName"
          placeholder="请输入计划名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="规则名称" prop="relTypeId" v-if="ruleFormXdd.planType == 'plus_card'">
        <el-select
            clearable
            filterable
            multiple 
            size="small"
            v-model="ruleFormXdd.relTypeId"
            placeholder="请选择规则名称"
          >
          <el-option
            :label="v.cardName"
            :value="v.plusRuleId"
            v-for="(v, i) in plusRuleList"
            :key="i"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计划人群" prop="relTypeIdList">
        <div>{{ renqun }}</div>
        <!-- <el-select
          size="small"
          @change="changeRenqun"
          placeholder="选择优惠券包"
          v-model="ruleFormXdd.planType"
          filterable
          style="width:120px"
          class="mr10"
        >
          <el-option label="会员卡类型" value="member_card"></el-option>
        </el-select>
        <el-select
          clearable
          v-if="ruleFormXdd.planType === 'member_card'"
          class="mr10"
          size="small"
          v-model="ruleFormXdd.relTypeIdList"
          placeholder="请选择卡类型"
          filterable
          multiple
        >
          <el-option
            :label="v.typeName"
            :value="v.cardTypeId"
            :key="i"
            v-for="(v, i) in cardTypeList"
          ></el-option>
        </el-select>
        <el-select
          v-if="ruleFormXdd.planType === 'group'"
          clearable
          multiple
          filterable
          size="small"
          v-model="ruleFormXdd.groupIds"
          placeholder="请选择会员群组"
        >
          <el-option
            :label="v.groupAppellation"
            :value="v.groupId"
            v-for="(v, i) in memberGroupList"
            :key="i"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="计算周期" prop="cycleDays">
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="ruleFormXdd.cycleDays"
          placeholder="请输入累计计算的周期"
          size="small"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width: 100px"
            v-model="ruleFormXdd.zq"
          >
            <el-option label="按天计算" value="today"></el-option>
            <!-- <el-option label="按月计算" value="month"></el-option>
            <el-option label="按年计算" value="years"></el-option> -->
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="消费阶梯" prop="cycleRelModelList">
        <!-- <div
          v-for="(v, index) in ruleFormXdd.cycleRelModelList"
          :key="index"
          class="mb20"
        > -->
        <!-- <div class="flex flex-wrap item-center">
            累计消费满
            <el-input
              size="small"
              clearable
              class="mr10 ml10 ipt"
              maxlength="60"
              style="width:100px"
              v-model.trim="v.limitAmount"
              @input="filterGt0OrFixed2(index, 'limitAmount')"
              placeholder=""
            ></el-input
            >元，送如下优惠券。
            <div>
              <div class="add-wrapper flex flex-center" v-if="index === 0">
                <span
                  class="hmicon icon-hao pointer"
                  @click="addChild(index)"
                ></span>
              </div>
              <div class="minus-wrapper flex flex-center" v-else>
                <span
                  class="hmicon icon-jianhao pointer"
                  @click="deleteChild(index)"
                ></span>
              </div>
            </div>
          </div> -->
        <div class="table-goods">
          <el-table
            :data="ruleFormXdd.cycleRelModelList"
            style="width: 100%"
            ref="table"
            stripe
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              label="发放优惠券门槛"
              prop="amountLowLimit"
            >
              <template slot-scope="scope">
                <div class="flex item-center">
                  累计消费满
                  <el-input
                    size="small"
                    clearable
                    class="mr10 ml10 ipt"
                    maxlength="60"
                    style="width: 100px"
                    v-model.trim="scope.row.amountLowLimit"
                    @input="filterGt0OrFixed2(scope.$index, 'amountLowLimit')"
                    placeholder=""
                  ></el-input
                  >元
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="优惠券包"
              prop="sendCouponCode"
            >
              <template slot-scope="scope">
                <el-select
                  clearable
                  filterable
                  size="small"
                  @change="
                    changeCounponList(scope.$index, scope.row.sendCouponCode)
                  "
                  v-model="scope.row.sendCouponCode"
                  placeholder="请选择会员群组"
                >
                  <el-option
                    :label="v.name"
                    :value="v.couponSendId"
                    v-for="(v, i) in scope.row.couponList"
                    :key="i"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="可发放组数"
              prop="couponsNum"
            >
              <template slot-scope="scope">
                <div class="blue">
                  {{
                    scope.row.couponsNum === "" ? "读取" : scope.row.couponsNum
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="发放组数"
              prop="totalSendNumber"
            >
              <template slot-scope="scope">
                <el-input
                  :disabled="!scope.row.sendCouponCode"
                  size="small"
                  clearable
                  class="ipt"
                  @input="filterGt0OrFixed0('totalSendNumber')"
                  v-model.trim="scope.row.totalSendNumber"
                  placeholder="请输入发放组数"
                ></el-input>
                <!-- <el-input
                    size="small"
                    clearable
                    class="mr10 ml10 ipt"
                    maxlength="18"
                    style="width:200px"
                    @input="filterGt0OrFixed2(index, scope.$index, 'prizeNum')"
                    v-model.trim="scope.row.prizeNum"
                    placeholder="请输入奖品数量"
                  ></el-input> -->
              </template>
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="操作"
            >
              <template slot-scope="scope" class="flex flex-center">
                <div>
                  <div
                    class="add-wrapper flex flex-center"
                    v-if="scope.$index === 0"
                  >
                    <span
                      class="hmicon icon-hao pointer"
                      @click="addChild(scope.$index)"
                    ></span>
                  </div>
                  <div class="minus-wrapper flex flex-center" v-else>
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteChild(scope.$index)"
                    ></span>
                  </div>
                </div>
                <!-- <div
                    class="add-wrapper flex flex-center"
                    v-if="scope.$index === 0"
                  >
                    <span
                      class="hmicon icon-hao pointer"
                      @click="addGoodChild(index, scope.$index)"
                    ></span>
                  </div>
                  <div class="minus-wrapper flex flex-center" v-else>
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteGoodChild(index, scope.$index)"
                    ></span>
                  </div> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- </div> -->
      </el-form-item>
      <el-form-item label="计划异常提醒" prop="reminderMobile">
        接收通知的手机号:<el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleFormXdd.reminderMobile"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <div class="flex flex-center">
        <el-button
          type="primary"
          size="small"
          @click="submitFormXdd('ruleFormXdd')"
          >确认</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    // const patterndplanType = function(rule, val, callback) {
    //   if (val === "automatic") {
    //     if (this.ruleForm.date.length < 1) {
    //       return callback(new Error("请选择自动长期计划时间"));
    //     }
    //   } else if (val === "manual") {
    //     if (this.ruleForm.planTypeTime === "timing") {
    //       if (this.ruleForm.planTime === "") {
    //         return callback(new Error("请选择定时执行时间"));
    //       }
    //     }
    //   }
    //   callback();
    // }.bind(this);
    // const patterndrelType = (rule, val, callback) => {
    //   if (val.length === 0) {
    //     return callback(new Error("请选择会员卡类型"));
    //   }
    //   callback();
    // };
    const patterndcycleRel = (rule, val, callback) => {
      let flag = false;
      val.forEach(v => {
        if (
          v.amountLowLimit === "" ||
          v.sendCouponCode === "" ||
          v.totalSendNumber === ""
        ) {
          flag = true;
        }
      });
      if (flag) {
        return callback(new Error("请填写完整消费阶梯"));
      } else {
        let show = false;
        val.forEach(v => {
          if (v.couponsNum < v.totalSendNumber) {
            show = true;
          }
        });
        if (show) {
          return callback(new Error("发放组数不得大于可发放组数"));
        }
      }
      callback();
    };
    const patterndCoupons = function(rule, val, callback) {
      if (val === "yes") {
        if (this.ruleForm.sendCouponCode === "") {
          return callback(new Error("请选择优惠券包"));
        } else {
          if (this.ruleForm.totalSendNumber === "") {
            return callback(new Error("请输入发放组数"));
          }
        }
      }
      callback();
    }.bind(this);
    const patterndPlanNotice = function(rule, val, callback) {
      if (val === "yes") {
        if (this.ruleForm.sendSmsContent === "") {
          return callback(new Error("请输入短信内容"));
        }
      }
      callback();
    }.bind(this);
    return {
      couponsList: [],
      ruleFormXdd: {
        planName: "",
        planType: "member_card",
        // relTypeIdList: [],
        groupIds: [],
        cycleDays: "",
        zq: "today",
        relTypeId:[],
        cycleRelModelList: [
          {
            amountLowLimit: "",
            couponList: [],
            sendCouponCode: "",
            couponsNum: "",
            totalSendNumber: ""
          }
        ],
        reminderMobile: ""
      },
      xddRules: {
        planName: [
          {
            required: true,
            max: 50,
            message: "长度在50个字符内",
            trigger: "blur"
          }
        ],
         relTypeId: [
          {
            required: true,
            message: "请选择规则名称",
            trigger: "change"
          }
        ],
        // relTypeIdList: [
        //   {
        //     required: true,
        //     validator: patterndrelType,
        //     trigger: "blur"
        //   }
        // ],
        cycleDays: {
          required: true,
          pattern: /^[1-9][0-9]*$/,
          message: "请输入正整数",
          trigger: "blur"
        },
        cycleRelModelList: {
          required: true,
          validator: patterndcycleRel,
          trigger: "blur"
        },
        reminderMobile: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ]
      },
      ruleForm: {
        planName: "",
        planType: "",
        // memberType: "",
        date: [],
        planTypeTime: "immediately",
        planTime: "",
        sendCouponState: "no",
        totalSendNumber: "",
        sendCouponCode: "",
        sendSmsState: "no",
        sendSmsContent: "",
        reminderMobile: "",
        cardTypeIdList: []
      },
      rules: {
        planName: [
          {
            required: true,
            max: 50,
            message: "长度在50个字符内",
            trigger: "blur"
          }
        ],
        cardTypeIdList: {
          required: true,
          message: "请选择绑定会员卡类型",
          trigger: "blur"
        },
        // memberType: {
        //   required: true,
        //   message: "请选择会员类型",
        //   trigger: "blur"
        // },
        date: [
          {
            required: true,
            message: "计划执行时间",
            trigger: "blur"
          }
          //   {
          //     required: true,
          //     validator: patterndplanType,
          //     trigger: "blur"
          //   }
        ],
        sendCouponState: [
          {
            validator: patterndCoupons,
            trigger: "blur"
          }
        ],
        sendSmsState: [
          {
            validator: patterndPlanNotice,
            trigger: "blur"
          }
        ],
        reminderMobile: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ]
      },
      renqun: this.$route.query.renqun,
      type: this.$route.query.type,
      couponsNum: "",
      cardTypeList: [],
      memberGroupList: [],
      couponList: [],
      vipCardTypeList: [],
      checked: false,
      plusRuleList:[]
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.ruleForm.planType = this.$route.query.type;
    this.ruleFormXdd.planType = this.$route.query.type;
    // let params = {
    //   operationPlan: "0"
    // };
    // this.$store.dispatch("findCouponSendB", params).then(res => {
    //   this.couponsList = res.result;
    // });
    this.$store.dispatch("findCouponSendByEvent").then(res => {
      if (res.code === "0") {
        this.couponList = res.result;
        this.ruleFormXdd.cycleRelModelList.forEach(v => {
          v.couponList = JSON.parse(JSON.stringify(this.couponList));
        });
      }
    });
    // this.queryCouponSendList();
    this.queryCardTypeList();
    this.queryVipCard();
    if(this.$route.query.type === "plus_card"){
      this.getPlusRuleList();
    }
  },
  methods: {
    async queryVipCard() {
      const { result } = await this.$store.dispatch("queryVipCardTypeList", {
        pageSize: 99999,
        pageNo: 1
      });
      this.vipCardTypeList = result.records;
    },
    validationCardType() {
      let cardList = this.ruleForm.cardTypeIdList;
      if (cardList.length) {
        if (cardList.indexOf("0") === 0) {
          this.checked = true;
          this.vipCardTypeList.filter(v => {
            v.disabled = true;
          });
        } else {
          this.checked = true;
          this.vipCardTypeList.filter(v => {
            if (cardList.indexOf(v.cardTypeId) !== -1) {
              v.disabled = true;
            } else {
              v.disabled = false;
            }
          });
        }
      } else {
        this.checked = false;
        this.vipCardTypeList.filter(v => {
          if (cardList.indexOf(v.cardTypeId) !== -1) {
            v.disabled = true;
          } else {
            v.disabled = false;
          }
        });
      }
    },

    changeRenqun(val) {
      if (val === "member_card") {
        this.queryCardTypeList();
      } else if (val === "group") {
        this.queryMemberGroupList();
      }
    },
    filterGt0OrFixed2(index, prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormXdd.cycleRelModelList[index][
        prop
      ] = this.ruleFormXdd.cycleRelModelList[index][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.ruleFormXdd.cycleRelModelList[index][
        prop
      ] = this.ruleFormXdd.cycleRelModelList[index][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.ruleFormXdd.cycleRelModelList[index][
        prop
      ] = this.ruleFormXdd.cycleRelModelList[index][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleFormXdd.cycleRelModelList[index][
        prop
      ] = this.ruleFormXdd.cycleRelModelList[index][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.ruleFormXdd.cycleRelModelList[index][prop].indexOf(".") < 0 &&
        this.ruleFormXdd.cycleRelModelList[index][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleFormXdd.cycleRelModelList[index][prop] = parseFloat(
          this.ruleFormXdd.cycleRelModelList[index][prop]
        );
      }
    },
    deleteChild(index) {
      this.ruleFormXdd.cycleRelModelList.splice(index, 1);
    },
    addChild() {
      this.ruleFormXdd.cycleRelModelList.push({
        amountLowLimit: "",
        couponList: JSON.parse(JSON.stringify(this.couponList)),
        sendCouponCode: "",
        couponsNum: "",
        totalSendNumber: ""
      });
    },
    deleteGoodChild(index, i) {
      this.ruleFormXdd.cycleRelModelList[index].drawPrizeModelList.splice(i, 1);
    },
    addGoodChild(index, i) {
      this.ruleFormXdd.cycleRelModelList[index].drawPrizeModelList.push({
        couponList: JSON.parse(JSON.stringify(this.couponList)),
        ruleIds: "",
        prizeNum: "1"
      });
    },
    async queryCouponSendList() {
      const { result } = await this.$store.dispatch("getAllRules", {
        isQueryExpired: 1,
        isSend: 1,
        pageNo: 1,
        pageSize: 99999,
        status: 1,
        sysTag: 0
      });
      const { records } = result;
      this.couponList = records;
      this.ruleFormXdd.cycleRelModelList.forEach(v => {
        v.couponList = JSON.parse(JSON.stringify(this.couponList));
      });
    },
    async queryMemberGroupList() {
      const { result } = await this.$store.dispatch("queryMemberGroupList", {
        pageNo: 1,
        pageSize: 9999
      });

      const { records } = result;
      this.memberGroupList = records;
    },
    async queryCardTypeList() {
      const { result } = await this.$store.dispatch("queryCardTypeList", {
        pageNo: 1,
        pageSize: 99999
      });
      this.cardTypeList = result;
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    changeCounpon(val) {
      this.couponList.map(v => {
        if (v.couponSendId === val) {
          this.couponsNum = v.send_num;
        }
      });
    },
    changeCounponList(i, val) {
      this.couponList.map(v => {
        if (v.couponSendId === val) {
          this.ruleFormXdd.cycleRelModelList[i].couponsNum = v.send_num;
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.couponsNum < this.ruleForm.totalSendNumber) {
            this.$message({
              message: "发放组数不得大于可发放组数",
              type: "warning"
            });
          } else {
            const params = JSON.parse(JSON.stringify(this.ruleForm));
            params.planStartDate = params.date[0];
            params.planEndDate = params.date[1];
            
              if (params.cardTypeIdList.indexOf("0") === 0) {
                params.cardTypeIds = "";
              } else {
                params.cardTypeIds = params.cardTypeIdList.join(",");
              }
            
            this.$store.dispatch("addCrmPlan", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          }
        } else {
          return false;
        }
      });
    },

submitFormXdd(formName) {
  this.$refs[formName].validate(valid => {
    if (valid) {
      const params = JSON.parse(JSON.stringify(this.ruleFormXdd));
      // 如果 planType 为 'plus_card'，则添加 relTypeIdList
      if (this.ruleFormXdd.planType == 'plus_card') {
        params.relTypeIdList = params.relTypeId;
      }else {
        delete params.relTypeId;
        delete params.relTypeIdList
      }
      this.$store.dispatch("addCrmPlan", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.$router.back(-1);
        }
      });
    } else {
      return false;
    }
  });
},

    
    getPlusRuleList() {
      let params = {
        pageNo: 1,
        pageSize: 999,
      };
      this.$store.dispatch("plusRuleList", params).then(res => {
        if (res.code === "0") {
          // 兼容不同的响应结构
          const data = res.result || res;
          // 确保 records 存在且为数组
          const records = Array.isArray(data) ? data : (data && Array.isArray(data.records) ? data.records : []);
          // 过滤出 cardType = 'basic' 且 enableState = 'yes' 的数据
          this.plusRuleList = records.filter(item => 
            item.cardType === 'basic'
          );
          console.log('PLUS会员规则列表:', res,data,records,this.plusRuleList);
        } else {
          console.error('获取PLUS会员规则列表失败:', res.message || res.msg);
          this.plusRuleList = []; // 确保列表为空数组
        }
      }).catch(error => {
        console.error('获取PLUS会员规则列表出错:', error);
        this.plusRuleList = []; // 确保列表为空数组
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.form-tips {
  color: #97a8be;
  font-size: 0.8rem;
}
.form-tips-primary {
  color: #e60e6d;
  font-size: 0.8rem;
}
.coupons-table {
  border: 1px solid #ddd;
  width: 1000px;
  .coupons-head {
    background: rgba(247, 247, 247, 1);
    border-radius: 6px;
  }
}
.table-goods {
  border: 1px solid #ddd;
}
</style>
